<template>
  <div class="l-content-inner">
    <div class="c-head">
      <h1 class="head-title">조색배합</h1>
      <BreadCrumb :breadcrumbs="getBreadcrumbItems" />
    </div>

    <div class="l-content">
      <!-- D: 조색배합 페이지 -->
      <div class="p-mising-wrap">
        <div class="l-white-box">
          <!-- D: 상단 탭 : AI 조색배합, 조색배합문의, 업데이트, 색상찾기, 컬러코드찾기 -->
          <div class="c-tabs">
            <ul>
              <li class="tab-item">
                <a
                  href="javascript:void(0);"
                  @click="btnCmd('tab1Click', { tab1Index: 0 })"
                  :class="[
                    'tab-anchor',
                    {
                      'is-active': data.tab1Index === 0,
                    },
                  ]"
                  role="tab"
                  aria-selected
                >
                  조색배합문의
                </a>
              </li>
              <!-- D: 활성화시 is-active 및 aria-selected 추가 -->
              <li class="tab-item">
                <a
                  href="javascript:void(0);"
                  @click="btnCmd('tab1Click', { tab1Index: 1 })"
                  :class="[
                    'tab-anchor',
                    {
                      'is-active': data.tab1Index === 1,
                    },
                  ]"
                  role="tab"
                  >업데이트</a
                >
              </li>
              <li class="tab-item">
                <a
                  href="javascript:void(0);"
                  @click="btnCmd('tab1Click', { tab1Index: 2 })"
                  :class="[
                    'tab-anchor',
                    {
                      'is-active': data.tab1Index === 2,
                    },
                  ]"
                  role="tab"
                  >색상찾기</a
                >
              </li>
              <li class="tab-item">
                <a
                  href="javascript:void(0);"
                  @click="btnCmd('tab1Click', { tab1Index: 3 })"
                  :class="[
                    'tab-anchor',
                    {
                      'is-active': data.tab1Index === 3,
                    },
                  ]"
                  role="tab"
                  >컬러코드찾기</a
                >
              </li>
              <!-- <li class="tab-item">
                <a
                  href="javascript:void(0);"
                  @click="btnCmd('tab1Click', { tab1Index: 4 })"
                  :class="[
                    'tab-anchor',
                    {
                      'is-active': data.tab1Index === 4,
                    },
                  ]"
                  role="tab"
                  aria-selected
                >
                  AI 조색배합
                </a>
              </li> -->
            </ul>
          </div>

          <!-- D: c-tab-panel과 c-tab-panel-wrap은 세트임 -->
          <!-- D: border가 없는경우 type-non-border 추가 -->
          <div class="c-tab-panel-wrap type-non-border">
            <!-- tab content: tab1 -->
            <div
              class="tab-panel"
              role="tabpanel"
              aria-labelledby="tab1-1"
              :hidden="data.tab1Index != 0"
            >
              <!-- D: 조색배합문의: 기본 -->
              <ColorCombinInqTab />
            </div>
            <!-- tab content: tab2 -->
            <div
              class="tab-panel"
              role="tabpanel"
              aria-labelledby="tab1-2"
              :hidden="data.tab1Index != 1"
            >
              <UpdateSearchList />
            </div>
            <!-- tab content: tab3 -->
            <div
              class="tab-panel"
              role="tabpanel"
              aria-labelledby="tab1-3"
              :hidden="data.tab1Index != 2"
            >
              <FindColorTab />
            </div>
            <!-- tab content: tab4 -->
            <div
              class="tab-panel"
              role="tabpanel"
              aria-labelledby="tab1-4"
              :hidden="data.tab1Index != 3"
            >
              <MunsellColorSearchList />
            </div>
            <!-- AI 조색배합 : tab1 -->
            <div            
              class="tab-panel"
              role="tabpanel"
              aria-labelledby="tab1-5"
              :hidden="data.tab1Index != 4"
            >
              <aiColorMatchingTab />
            </div>
          </div>

          <!-- 조색관련 문의 -->
          <div class="c-customer-footer">
            <div class="section">
              <strong class="subject">칼라런트팀에 조색관련 문의하기</strong>
              <div class="tel-group">
                <p class="text">조색문의</p>
                <p class="tel">
                  <a href="tel:031-467-6389">031-467-6389</a>
                </p>
              </div>
              <ul class="inquiry-time">
                <li>평일 - 09:00~18:00(일,공휴일 휴무)</li>
                <li>점심시간 - 12:00~13:00</li>
              </ul>
            </div>
            <div class="section">
              <div class="tel-group">
                <p class="text">고객문의</p>
                <p class="tel">
                  <a href="tel:080-944-7777">080-944-7777</a>
                </p>
              </div>
              <ul class="inquiry-time">
                <li>평일 - 09:00~18:00(일,공휴일 휴무)</li>
                <li>점심시간 - 12:00~13:00</li>
              </ul>
            </div>
            <div class="section">
              <a
                href="javascript:void(0);"
                class="btn-tel"
                @click="btnCmd('remoteSupport', {})"
              >
                <i class="c-icon icon-tel size-xmedium"></i>
                <span class="text">원격지원</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <QuickMenu />
  </div>

  <!-- D: POPUP - Wrap밖으로 호출 필요 -->
  <UpdateDetailDescPop v-if="data.popup.isModallVisible" />
  <ColorCombinMngPop v-if="data.popup.isModallVisible2" />
</template>
<script setup name="updateList">
import { onMounted, reactive, watch, computed } from "vue";

import QuickMenu from "@/components/paintpro/quickMenu/quickMenu.vue";
import BreadCrumb from "@/components/paintpro/base/breadCrumb.vue";
import ColorCombinInqTab from "@/components/paintpro/colorCombin/colorCombinInqTab.vue";
import UpdateSearchList from "@/components/paintpro/colorCombin/updateSearchList.vue";
import ColorCombinMngPop from "@/components/paintpro/colorCombin/colorCombinMngPop.vue";
import UpdateDetailDescPop from "@/components/paintpro/colorCombin/updateDetailDescPop.vue";
import FindColorTab from "@/components/paintpro/colorCombin/findColorTab.vue";
import MunsellColorSearchList from "@/components/paintpro/colorCombin/munsellColorSearchList.vue";
import aiColorMatchingTab from "@/components/paintpro/colorCombin/aiColorMatchingTab.vue";

import { useRoute, useRouter } from "vue-router";
import * as store from "@/store";
import * as cmApi from "@/api/cmApi";
import * as cmUtil from "@/utils/cmUtil.js";

const router = useRouter();

/***********************
 * 데이타 모음
 **********************/
const data = reactive({
  page: {
    token: "",
    isLogin: false,
    basketCount: 0,
    userLoginInfo: {},
    breadcrumbItems: [],
    query: {},
  },
  codes: {
    code01: [],
    code02: [],
  },
  popup: {
    isModallVisible: false,
    isModallVisible2: false,
  },
  tab1Index: 0,
});

watch(
  () => store.useBasketCountStore().basketCount,
  (newValue) => {
    data.page.basketCount = newValue;
  }
);

/**********************
 * 마운트
 *********************/
onMounted(() => {
  pageInit(); // 페이지 초기화 호출
});

/*********************
 * 페이지 초기함
 *********************/
async function pageInit() {
  data.page.query = useRoute().query || {};
  data.tab1Index = 1;
  await pageInitData();
}

/**********************
 * 페이지 초기 데이타 조회
 *********************/
async function pageInitData() {
  // ◼◼◼ 초기데이타 조회
  const mparm = [];
  const res = await cmApi.getPageInitData(mparm);
  const { resultCode } = res;
  if (resultCode !== 200) {
    //alert(`errror : resultCode:${resultCode}, message:${message} :: [호출: updateList.pageInitData] `);
    return false;
  }
  data.page.token = cmUtil.getLocalStorage("token");
  data.page.isLogin = store.useAuthStore()?.user ? true : false;
  data.page.userLoginInfo = store.useAuthStore()?.user;
}

const getBreadcrumbItems = computed(() => {
  let list = [
    { name: "조색배합", path: "/paintpro/colorCombinList" },
    { name: "업데이트", path: "" },
  ];
  return list;
});

/**********************
 * 버튼 클릭 모음
 *********************/
async function btnCmd(cmd = "", parms = {}) {
  if (cmd === "tab1Click") {
    data.tab1Index = parms.tab1Index;
    if (parms.tab1Index === 0) {
      router.push({
        path: "/paintpro/colorCombinList",
      });
    } else if (parms.tab1Index === 1) {
      router.push({
        path: "/paintpro/colorCombinList/updateList",
      });
    } else if (parms.tab1Index === 2) {
      router.push({
        path: "/paintpro/colorCombinList/colorSearch",
      });
    } else if (parms.tab1Index === 3) {
      router.push({
        path: "/paintpro/colorCombinList/munsellColorSearch",
      });    
    } else if (parms.tab1Index === 4) {
      router.push({
        path: "/paintpro/colorCombinList/aiColormatching",
      });
    }
  }
  // 원격지원
  else if (cmd == "remoteSupport") {
    const _url = "http://ezh.kr/noroo1/";
    window.open(_url, "_blank");
  } else {
    alert(`[개발확인] btnCmd() cmd [${cmd}] 를 확인해주세요` + parms);
    return false;
  }
}
</script>
<style scoped></style>
